module.exports = __webpack_public_path__ + "img/close-icon.51283b16.svg";